export default __webpack_public_path__ + "static/media/video-img.09069b22.jpg";